import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../i18n/eng.json'
import translationTR from '../i18n/tr.json'

const resources = {
  tr: {
    translation: translationTR
  },
  eng: {
    translation: translationEN
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('activeLanguage') || 'tr',

  interpolation: {
    escapeValue: false
  }
});

export default i18n;